import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from 'src/api.config';
import { LocationVersion } from '../models/location-version';
import { CreateLocationVersionRequest } from '../requests/create-location-version-request';
import { ListLocationVersionRequest } from '../requests/list-location-version-request';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LocationVersionService extends BaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }
  public listLocationVersions(req: ListLocationVersionRequest) {
    let resource = `${this.apiUrl}/${api.v1.locationVersions}`;
    let params = new HttpParams();
    params = params.append('current', req.current);
    params = params.append('desc', req.desc);

    return this.http.get<LocationVersion[]>(resource, {params: params})
  } 

  public getLocationVersion(year: number) {
    let resource = `${this.apiUrl}/${api.v1.locationVersions}/${year}`;
    return this.http.get<LocationVersion>(resource);
  }

  public createLocationVersion(locationVersion: CreateLocationVersionRequest) {
    let resource = `${this.apiUrl}/${api.v1.locationVersions}`;
    return this.http.post<LocationVersion>(resource, locationVersion);
  }

  public deleteLocationVersion(id: string) {
    let resource = `${this.apiUrl}/${api.v1.locationVersions}/${id}`;
    return this.http.delete(resource);
  }
}
